import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, inject, input, output } from '@angular/core';
import { AssetDto, AssetVersionDto, GalleryDto } from '@nusign/picflow-backend-types';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';

@Component({
  selector: 'app-pdf-page-list',
  imports: [AssetVersionUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pdf-page-list.component.html',
  styleUrl: './pdf-page-list.component.scss',
})
export class PdfPageListComponent {
  private el = inject(ElementRef) as ElementRef<HTMLElement>;
  asset = input.required<AssetDto>();
  gallery = input.required<GalleryDto>();
  version = input.required<AssetVersionDto>();
  activePage = input.required<number>();
  switchPage = output<number>();

  pages = computed(() => {
    const version = this.version();
    if (!version) return;
    return version.data['images'] as { key: string; width: number; height: number }[];
  });

  constructor() {
    effect(() => {
      const activePage = this.activePage();
      this.el.nativeElement.querySelector(`.pdf-page:nth-child(${activePage + 1})`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    });
  }
}
